import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";

import UserList from "./components/private/userList/userList.tsx";

import Home from "./components/public/home/home.jsx";
import About from "./components/public/about/about.tsx";
import RegisterCard from "./components/public/register/registerCard.jsx";
import Contact from "./components/public/contact/contact.tsx";
import TermsAndCondition from "./components/public/termsAndCondition/termsAndCondition.tsx";
import PrivacyPolicy from "./components/public/privacyAndPolicy/privacyAndPolicy.tsx";
import FAQ from "./components/public/faq/faq.tsx";

import SessionTimeout from "./components/common/sessionTimeout/sessionTimeout.tsx";
import ScrollToTop from "./components/common/scrollToTop/scrollToTop.tsx";

function App() {
  return (
    <BrowserRouter>
      {/* Scroll to top whenever route changes */}
      <ScrollToTop />

      {/* Global session timeout handler */}
      <SessionTimeout />

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path='/register' element={<RegisterCard />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/faq' element={<FAQ />} />
        <Route
          path='/terms-and-conditions'
          element={<TermsAndCondition />}
        />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />

        {/* Protected Routes */}
        <Route
          path='/dashboard'
          element={
            <ProtectedRoute>
              <UserList />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;